import { render, staticRenderFns } from "./EditMemberAddressConfigDialog.vue?vue&type=template&id=568f0290&scoped=true&lang=pug&"
import script from "./EditMemberAddressConfigDialog.vue?vue&type=script&lang=ts&"
export * from "./EditMemberAddressConfigDialog.vue?vue&type=script&lang=ts&"
import style0 from "./EditMemberAddressConfigDialog.vue?vue&type=style&index=0&id=568f0290&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568f0290",
  null
  
)

export default component.exports